
import { sendError } from '../../youwell-common/errorUtils';

let myPeerConnection;
let negotiationStarted = false;

const videoPeerConnections = {

    endPeerConnection: () => {
        if (myPeerConnection) {
            myPeerConnection.onIceCandidate = null;
            myPeerConnection.ontrack = null;
            myPeerConnection.onnegotiationneeded = null;
            myPeerConnection.onremovetrack = null;
            myPeerConnection.oniceconnectionstatechange = null;
            myPeerConnection.onicegatheringstatechange = null;
            myPeerConnection.onicecandidateerror = null;
            myPeerConnection.onsignalingstatechange = null;
            myPeerConnection.close();
            myPeerConnection = null;
            negotiationStarted = false;
        }
    },

    startPeerConnection: (id, sendCandidateCallback, remoteTrackCallback, trackRemovedCallback, disconnectedCallback) => {
        myPeerConnection = new RTCPeerConnection({
            iceServers: [
            ],
        });

        myPeerConnection.onicecandidate = (evt) => {
            if (evt.candidate) {
                sendCandidateCallback({
                    target: id,
                    type: 'new-ice-candidate',
                    data: evt.candidate,
                });
            }
        };
        myPeerConnection.ontrack = (evt) => { remoteTrackCallback(evt.streams[0]); };
        myPeerConnection.onnegotiationneeded = () => {
            if (!negotiationStarted) {
                negotiationStarted = true;
            }
        };
        myPeerConnection.onremovetrack = () => trackRemovedCallback();
        myPeerConnection.oniceconnectionstatechange = () => {
            switch (myPeerConnection.iceConnectionState) {
            case 'closed':
            case 'failed':
            case 'disconnected':
                disconnectedCallback();
                break;
            default:
                break;
            }
        };
        // myPeerConnection.onicegatheringstatechange = (evt) => { console.log(`Ice connection state change: ${myPeerConnection.iceConnectionState}`); };
        myPeerConnection.onicecandidateerror = error => sendError({ sender: 'VideoPeerConnection', error: error && error.toString() });
        myPeerConnection.onsignalingstatechange = () => {
            switch (myPeerConnection.signalingState) {
            case 'closed':
                disconnectedCallback();
                break;
            default:
                break;
            }
        };
    },

    setupPeerConnectionStream: (localStream) => {
        localStream.getTracks().forEach(track => myPeerConnection.addTrack(track, localStream));
    },

    answerPeerConnection: (myId, offerSDP, createAnswerCallback) => {
        const remoteSDP = new RTCSessionDescription({
            type: 'offer',
            sdp: offerSDP,
        });

        myPeerConnection.setRemoteDescription(remoteSDP)
            .then(() => {
                myPeerConnection.createAnswer()
                    .then((answer) => { myPeerConnection.setLocalDescription(answer); return answer; })
                    .then((answer) => {
                        createAnswerCallback({
                            target: myId,
                            type: 'videochat-answer',
                            data: answer.sdp,
                        });
                    })
                    .catch(error => sendError({ sender: 'VideoPeerConnection', error: error && error.toString() }));
            }).catch(error => sendError({ sender: 'VideoPeerConnection', error: error && error.toString() }));
    },

    receiveIceCandidate: (candidateData) => {
        myPeerConnection.addIceCandidate(candidateData);
    },
};

export default videoPeerConnections;
